<template>
  <div>
    <article-view :article="article"/>
    <div class="text-center">
      <mdb-btn icon="angle-left" @click='$router.back()' class="py-2 px-2"> 돌아가기</mdb-btn>
      <mdb-btn v-if="isOwner" @click='onEdit' icon="edit" color="primary" class="py-2 px-2"> 수정</mdb-btn>
      <mdb-btn v-if="isOwner" @click='onRemove' icon="trash-alt" color="danger" class="py-2 px-2"> 삭제</mdb-btn>
    </div>
    <comment-write v-if="isLogin && !isOwner" :article="article" class="mt-5" @add-comment="onAddComment"/>
    <comment-list :articleId="article._id" :comments="article.comments"/>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import ArticleView from '@/components/article/Article';
import CommentWrite from '@/components/article/CommentWrite';
import CommentList from '@/components/article/CommentList';
export default {
  name: 'BoardDetail',
  components: { ArticleView, CommentWrite, CommentList },
  data: () => ({
    article: {}
  }),
  computed: {
    ...mapState('auth', ['profile']),
    ...mapGetters('auth', ['isLogin']),
    isOwner () {
      if (!this.profile._id || !this.article.writer) return false
      return this.profile._id === this.article.writer._id;
    }
  },
  methods: {
    back () {
      this.$router.back();
    },
    // 수정
    onEdit () {
      this.$router.push({
        name: 'BoardEdit',
        params: { _id: this.$route.params._id }
      });
    },
    // 삭제
    async onRemove () {
      if (confirm('삭제할까요')) {
        await this.article.delete();
        this.$router.back();
      }
    },
    onAddComment (comment) {
      this.article.comments.push(comment)
    }
  },
  async created () {
    this.article = await this.$Article.get(this.$route.params._id);
  }
}
</script>
